import React from 'react';
import proptypes from 'prop-types';
import { Link, Typography } from '@one-thd/sui-atomic-components';

const { string, bool } = proptypes;

export const Text = ({
  isLarge = false,
  text,
  isTitle = false,
  isTiny = false,
  boldText = '',
  linkText = '',
  linkUrl = ''
}) => {
  if (boldText) {
    return (
      <div>
        <Typography
          component="span"
          variant={isLarge ? 'body-lg' : 'body-base'}
          weight="bold"
          height="tight"
        >
          {boldText}
        </Typography>
        <Typography
          component="span"
          variant={isLarge ? 'body-lg' : 'body-base'}
          weight="regular"
          height="tight"
        >
          {text}
        </Typography>
      </div>
    );
  }

  if (isTitle) {
    return (
      <Typography
        variant="h3"
        weight="bold"
        height="tight"
      >
        {text}
      </Typography>
    );
  }

  if (linkText) {
    return (
      <div>
        <Typography
          component="span"
          variant="body-base"
          weight="regular"
          height="normal"
        >
          {text}
        </Typography>
        <Link
          target="_blank"
          href={linkUrl}
          variant="body-base"
          weight="regular"
          height="tight"
          underline="always"
        >
          {linkText}
        </Link>
      </div>
    );
  }

  let variant = 'body-base';
  if (isTiny) {
    variant = 'body-xs';
  } else if (isLarge) {
    variant = 'body-lg';
  }

  return (
    <Typography
      variant={variant}
      weight="regular"
      height={isTiny ? 'tight' : 'normal'}
    >
      {text}
    </Typography>
  );
};

Text.propTypes = {
  text: string.isRequired,
  isTitle: bool,
  isTiny: bool,
  boldText: string,
  linkText: string,
  isLarge: bool,
  linkUrl: string
};


